import { Component, input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SimpleInputModule } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'iw-advcash-form',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    SimpleInputModule,
    TranslateModule,
  ],
  templateUrl: './advcash-form.component.html',
  styleUrl: './advcash-form.component.scss',
})
export class AdvcashFormComponent {
  form = input<FormGroup>();
}
